module.exports = __webpack_public_path__ + "static/img/02.561c8b78.png";